import api from '@/service/api';
import variables from "@/service/variables";
export default class SapService {
     
    
    GetSAPMFG( lstVendor) {
        return api.post(variables.API_URL +'/api/SAPRFC/GetSAPMFG', lstVendor)
    }
    GetSAPVendorCode( lstVendor) {
        return api.post(variables.API_URL +'/api/SAPRFC/GetSAPVendorCode', lstVendor)
    }

    GetSpuervisorSAPVendorCode( lstVendor) {
        return api.get(variables.API_URL +'/api/SAPRFC/GetSpuervisorSAPVendorCode/' +  lstVendor)
    }
    GetSpuervisorSAPMFG( lstVendor) {
        return api.get(variables.API_URL +'/api/SAPRFC/GetSpuervisorSAPMFG/' +  lstVendor)
    }
    
}